import authServiceClient from "./authServiceClient";
import QUERY_SIGN_OUT from "./queries/QUERY_SIGN_OUT";
import { QuerySignOut } from "./queries/__generated__/QuerySignOut";

export default () => {
  return authServiceClient.mutate<QuerySignOut>({
    mutation: QUERY_SIGN_OUT
  });
};
